import React, { Fragment } from "react"
import { Grid, Typography, SxProps, styled } from "@mui/material"

import { colors } from "theme"

interface ItemType {
  label: string
  value?: string
}

type Props = React.HTMLAttributes<HTMLDivElement> & {
  sx?: SxProps
  dense?: boolean
  items: ItemType[]
}

const InfoListComponent = ({ items, dense = false, sx }: Props) => {
  const filteredItems = items.filter((item: ItemType) => item.value)

  return (
    <Container
      sx={sx}
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      {filteredItems.map(({ label, value }: ItemType, index: number) => (
        <Fragment key={index}>
          <Item
            sx={{
              padding: dense ? "7px 0" : "14px 0",
            }}
          >
            <Typography component="span" variant="body1">
              {label}
            </Typography>
            <Typography component="span" variant="body2" align="right">
              {value}
            </Typography>
          </Item>
        </Fragment>
      ))}
    </Container>
  )
}

InfoListComponent.defaultProps = {
  dense: false,
}

export default InfoListComponent

const Container = styled(Grid)(() => ({
  padding: "0",
  margin: "0",
}))

const Item = styled(Grid)(() => ({
  borderBottom: `1px solid ${colors.cultured}`,
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  width: "100%",
  "&:last-child": {
    border: "none",
  },
}))
